import React, { useCallback } from 'react';
import { Typography } from '@mui/material';
import ToggleButton from '@mui/material/ToggleButton';
import makeStyles from '@mui/styles/makeStyles';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import { Tooltip } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { useMessages } from 'modules/intl';
import { SortOrder } from 'graphql/types';
import { useNotesSortContext } from './NotesSortContextProvider';

const useToggleGroupStyle = makeStyles((theme) => ({
  grouped: {
    margin: theme.spacing(1, 2, 1, 2)
  },
  sortTitle: {
    color: `${theme.palette.text.secondary}`,
    ...theme.typography.subtitle2,
    whiteSpace: 'nowrap'
  },
  togglebtn: {
    border: 'none',
    backgroundColor: `${theme.palette.grey[300]}`,
    '&[aria-pressed=true]': {
      color: theme.palette.background.default,
      backgroundColor: `${theme.palette.primary.main}`,
      '&:hover': {
        backgroundColor: `${theme.palette.primary.dark}`
      }
    },
    '&:hover': {
      backgroundColor: `${theme.palette.grey[400]}`
    }
  },
  icons: {
    fontSize: 'small'
  }
}));
const messageIds = ['sort.tooltips.descending', 'sort.tooltips.ascending'];

export const NoteSortOrderSelector: React.FC = () => {
  const messages = useMessages(messageIds);
  const classes = useToggleGroupStyle();
  const { sortOrder, setSortOrder } = useNotesSortContext();
  const descendingTooltip = messages['sort.tooltips.descending'];
  const ascendingTooltip = messages['sort.tooltips.ascending'];

  const handleSort = useCallback(
    (event, newSortOrder) => {
      if (newSortOrder !== null) setSortOrder(newSortOrder);
    },
    [setSortOrder]
  );

  return (
    <>
      <Typography className={classes.sortTitle}>
        <FormattedMessage id="sort.title" />
      </Typography>
      <ToggleButtonGroup
        className={classes.grouped}
        size="small"
        value={sortOrder}
        onChange={handleSort}
        exclusive
      >
        <ToggleButton
          className={classes.togglebtn}
          value={SortOrder.Descending}
          aria-label={descendingTooltip}
        >
          <Tooltip title={descendingTooltip}>
            <ArrowDownwardIcon className={classes.icons} />
          </Tooltip>
        </ToggleButton>
        <ToggleButton
          className={classes.togglebtn}
          value={SortOrder.Ascending}
          aria-label={ascendingTooltip}
        >
          <Tooltip title={ascendingTooltip}>
            <ArrowUpwardIcon className={classes.icons} />
          </Tooltip>
        </ToggleButton>
      </ToggleButtonGroup>
    </>
  );
};
export default NoteSortOrderSelector;
